import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
  mixins: [style],
})
export default class SkillGroupLink extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '秒杀组列表';

  width = '800px';

  cancelText = '关闭';

  mounted() {
    this.getDataList();
  }

  getDataList() {
    const postParams = {
      page: this.page,
      status: 6,
      pageSize: this.pageSize,
      keyword: this.keyword,
      siteCodes: this.siteCodes,
    };
    IPSService.secKillGroupList({ postParams }).then((response: ItemObject) => {
      this.total = response.count;
      if (response.list.length > 0) {
        response.list.forEach((item) => {
          item.skgName = Functions.emptyVaribleHandler(item.skgName);
          // item.productNamList = item.productNamList.length > 0 ? item.productNamList.join(",") : '/';
          item.updatePerson = Functions.emptyVaribleHandler(item.updatePerson);
          item.actBeginTime = Functions.timeFormatSec(item.actBeginTime);
          item.actEndTime = Functions.timeFormatSec(item.actEndTime);
          item.actBeginTime = `${item.actBeginTime}~${item.actEndTime}`;
          item.updateTime = Functions.timeFormatSec(item.updateTime);
          item.beforeBeginTime = Functions.timeFormatSec(item.beforeBeginTime);

          // 计算秒杀价
          // let sold = 0;
          // let seckillStock = 0;
          // item.proportion = item.seckillStock ? `${(item.sold * 100) / item.seckillStock}%` : "0%";
          // // 累加库存
          // if (item.skuItems && item.skuItems.length > 0) {
          //   // 写入已售库存 和 占比
          //   item.skuItems.forEach((sItem) => {
          //     sItem["sold"] = sItem.totalStock - sItem.hasStock; // 已售库存
          //     const proportion1 = sItem.totalStock > 0 ? (sItem.sold * 100) / sItem.totalStock : 0;
          //     sItem["proportion"] = proportion1 > 0 ? `${proportion1.toFixed(2)}%` : "0%"; // 已售库存
          //     sItem.specVal = Functions.emptyVaribleHandler(sItem.specVal); // 规格
          //   });
          //   // 计算规格总数
          //   item.skuItems.forEach((sItem) => {
          //     seckillStock = seckillStock + sItem.totalStock; // 总库存
          //     sold = sold + sItem.sold; // 已售库存
          //   });
          // }
          //
          // item["seckillStock"] = seckillStock; // 秒杀库存
          // item["sold"] = sold; // 已售库存
          // const proportion2 = seckillStock > 0 ? (sold * 100) / seckillStock : 0;
          // item["proportion"] = proportion2 > 0 ? `${proportion2.toFixed(2)}%` : "0%";
        });
      }
      this.dataList = response.list;
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getDataList();
  }

  onPageChange(val) {
    this.page = val;
    this.getDataList();
  }

  onSelect(id, name) {
    this.$emit('result', { id, name });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getDataList();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="秒杀组标题"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="55" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="skgId" label="秒杀组ID" show-overflow-tooltip width="80" align="center"></el-table-column>
          <el-table-column prop="skgName" label="秒杀组标题" show-overflow-tooltip width="140"></el-table-column>
          <el-table-column prop="beforeBeginTime" label="预热开始时间" show-overflow-tooltip width="160"></el-table-column>
          <el-table-column prop="actBeginTime" label="活动期间" width="280" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="操作"
            width="80px"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.skgId, scope.row.skgName)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper" style="justify-content: flex-end;">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
